import styled from "styled-components"

const Style = {
  ScrollContainer: styled.div`
    width: 100%;
    height: 95px;
    overflow: hidden;
    position: relative;
    background: transparent;
    scroll-behavior: auto;
  `
}

export default Style